const strings = {
  common: {
    herba: "Herba",
    cancel: "Cancel",
    save: "Save Updates",
    user: "User",
    account: "Account",
    email: "Email",
    search: "Search",
    filter: {
      title: "Filter",
      selectOne: "Select One",
      true: "True",
      false: "False",
      where: "Where",
      is: "Is",
      multiFilter: (filterAmt: number) => `${filterAmt} Filter`,
      clear: "Clear Filter",
      deviceName: "Device Name",
      deviceLocation: "Location",
      deviceWater: "Has Water",
      deviceBattery: "Has Battery",
      deviceOnline: "Is Online",
    },
    mapAlt: (mapName: string) => `Map of ${mapName}`,
    export: (exportAmt: number) => `Export Selected (${exportAmt})`,
  },
};

export default strings;
